import { Component, OnInit, Input } from '@angular/core';
import { RecruitingService } from 'src/app/recruiting/recruiting.service';
import { StateLicensureDetails } from 'src/app/recruiting/jobs/recruiting-state-details/models/state-licensure-details.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, map } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'nova-recruiting-state-details',
    templateUrl: './recruiting-state-details.component.html',
    styleUrls: ['./recruiting-state-details.component.scss']
})
export class RecruitingStateDetailsComponent implements OnInit {
    @Input() itemId = null;

    stateData = new Array<StateLicensureDetails>();
    showDetails = false;
    stateLicensure = new StateLicensureDetails();
    selectedState = new StateLicensureDetails();
    isEditMode = false;
    stateLicensureAttachedDocs: any = [];
    breakpointObserver$: Observable<boolean>;

    constructor(
        private readonly _recruitingService: RecruitingService,
        private readonly _breakpointObserver: BreakpointObserver
    ) {}

    ngOnInit(): void {
        this.breakpointObserver$ = this._breakpointObserver
            .observe([Breakpoints.XSmall])
            .pipe(map((result) => result.matches));
        const details$ = this._recruitingService.getLicensureDetails(this.itemId);
        if (details$ !== null && details$ !== undefined) {
            details$.pipe(untilDestroyed(this)).subscribe((data) => {
                if (data) {
                    this.stateData = data;
                    this.onChanges();
                }
            });
        }
    }

    onChanges() {
        if (this.itemId) {
            this.stateLicensure = this.stateData.find((stateLicensure) => stateLicensure.stateId === this.itemId);
            this.selectedState = this.stateLicensure;
            this.getFileData();
        }
    }

    detailsHandler = function () {
        this.showDetails = true;
    };

    hideDetails = function () {
        this.showDetails = false;
    };

    downloadFile = function (id, fileName) {
        this.showProgressBar = true;
        this._recruitingService
            .getLicensureFile(this.itemId, id)
            .pipe(untilDestroyed(this))
            .subscribe({
                next: (result) => {
                    const a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style.cssText = 'display: none';

                    const url = window.URL.createObjectURL(result.body);
                    a.href = url;
                    a.download = fileName;
                    a.click();
                    window.URL.revokeObjectURL(url);

                    this.showProgressBar = false;
                },
                error: () => {
                    this.showProgressBar = false;
                    this.toasterService.toast('File was not found');
                }
            });
    };

    getFileData = function () {
        this._recruitingService
            .getLicensureFiles(this.itemId)
            .pipe(untilDestroyed(this))
            .subscribe((x) => {
                this.stateLicensureAttachedDocs = x;
            });
    };

    bindHtmlLinks = (text) => {
        const regEmail = /([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})/gi;
        const tmpEmail = '<a href="mailto:$1" target="_blank" rel="noopener">$1</a>';

        const regLink = /(https?:\/\/\S+\b)/gi;
        const tmpLink = '<a href="$1" target="_blank" rel="noopener">$1</a>';

        return typeof text === 'string' ? text.replace(regEmail, tmpEmail).replace(regLink, tmpLink) : '';
    };
}
